import { render, staticRenderFns } from "./floatPanel.vue?vue&type=template&id=2ec8cfb2&scoped=true"
import script from "./floatPanel.vue?vue&type=script&lang=js"
export * from "./floatPanel.vue?vue&type=script&lang=js"
import style0 from "./floatPanel.vue?vue&type=style&index=0&id=2ec8cfb2&prod&lang=css"
import style1 from "./floatPanel.vue?vue&type=style&index=1&id=2ec8cfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8cfb2",
  null
  
)

export default component.exports